import { useId, useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

export const temporaryPersonLabel = 'Temporal · només per a aquest esdeveniment';

export function TemporaryPersonClock({ size = 15 }) {
    return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
        <circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" />
    </svg>;
}

export default function TemporaryPersonBadge() {
    const [open, setOpen] = useState(false);
    const tooltipId = useId();
    const button = useRef(null);
    const tooltip = useRef(null);
    const [position, setPosition] = useState({ left: 0, top: 0 });
    const label = temporaryPersonLabel;
    const stop = event => event.stopPropagation();
    useLayoutEffect(() => {
        if (!open) return;
        const place = () => {
            const rect = button.current.getBoundingClientRect();
            const width = tooltip.current.offsetWidth;
            const height = tooltip.current.offsetHeight;
            setPosition({ left: Math.max(12, Math.min(rect.right - width, window.innerWidth - width - 12)),
                top: rect.top > height + 18 ? rect.top - height - 6 : rect.bottom + 6 });
        };
        const outside = event => { if (!button.current?.contains(event.target)) setOpen(false); };
        place();
        window.addEventListener('resize', place);
        window.addEventListener('scroll', place, true);
        document.addEventListener('pointerdown', outside);
        return () => {
            window.removeEventListener('resize', place);
            window.removeEventListener('scroll', place, true);
            document.removeEventListener('pointerdown', outside);
        };
    }, [open]);
    return <span className="temporary-person-badge" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
        <button ref={button} type="button" aria-label={label} aria-describedby={open ? tooltipId : undefined}
            onPointerDown={stop} onPointerUp={stop} onTouchStart={stop} onTouchEnd={stop}
            onClick={event => { stop(event); setOpen(true); }}
            onFocus={() => setOpen(true)} onBlur={() => setOpen(false)}
            onKeyUp={stop} onKeyDown={event => { stop(event); if (event.key === 'Escape') { event.preventDefault(); setOpen(false); } }}>
            <TemporaryPersonClock />
        </button>
        {open && createPortal(<span ref={tooltip} id={tooltipId} role="tooltip" className="temporary-person-tooltip" style={position}>{label}</span>, document.body)}
    </span>;
}
